import { Outlet } from 'react-router-dom';

/**
 * This layout is dedicated for the PWA Download Page
 * @returns Outlet
 */
export default function LogoOnlyLayout() {
  return <Outlet />;
}
